<div class="address-smart-input">
  <kc-input
    [infoLabel]="{ label: label() }"
    [placeholder]="placeholder()"
    [type]="'text'"
    [isValid]="
      isResolving() || isDomainCandidate()
        ? true
        : displayIsValid() && !resolveError()
    "
    [isDisabled]="isDisabled()"
    [ngModel]="inputValue()"
    (valueChange)="onInputChange($any($event))"
  >
    <!-- Right slot: QR and spinner -->
    <div class="right-slot" rightSideSlot>
      @if (isResolving()) {
        <kc-spinner [size]="'xs'" />
      } @else if (showQrButton()) {
        <div
          (click)="!isDisabled() && qrClick.emit()"
          [class]="isDisabled() ? 'qr-button disabled' : 'qr-button clickable'"
          kcTooltip="Scan QR code"
          tooltipPosition="left-center"
        >
          <kc-icon
            [iconClass]="'icon-qr'"
            [size]="'xs'"
            [color]="'var(--gray-60)'"
          />
        </div>
      }
    </div>
  </kc-input>
  @if (
    !isResolving() &&
    !isDomainCandidate() &&
    (resolveError() || displayInvalidReason())
  ) {
    <span class="kc-input-error-text">{{
      resolveError() || displayInvalidReason()
    }}</span>
  }

  @if (
    resolvedAddress() && resolvedDomain() && inputValue() && !isResolving()
  ) {
    <div class="resolved-address flex align-items-center gap-8">
      <div class="font-mono">{{ shortenAddress(resolvedAddress()) }}</div>
      <app-copy-button [value]="resolvedAddress()" [size]="'xs'" />
    </div>
  }

  @if (
    inputValue() &&
    !isResolving() &&
    (resolvedAddress() || (!resolveError() && displayIsValid()))
  ) {
    <!-- Verification warning text for all valid addresses -->
    <div class="address-warning-text">
      Please verify that this is the correct wallet address before sending.
      Transactions cannot be reversed.
    </div>
  }
</div>
